export default function Tooltips () {

let tooltips = document.querySelectorAll('.tooltip');


[].forEach.call(tooltips, (tooltip) => {
	
	tooltip.addEventListener('touchend', (e)=>{
		e.preventDefault();
		tooltip.classList.toggle('tooltip_active');
	});


});


}